import { render, staticRenderFns } from "./PushMsg.vue?vue&type=template&id=5f5e8cde&"
import script from "./PushMsg.vue?vue&type=script&lang=js&"
export * from "./PushMsg.vue?vue&type=script&lang=js&"
import style0 from "./PushMsg.vue?vue&type=style&index=0&id=5f5e8cde&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports